import {getTestProps} from '@benchling/js-test-utils';
import React from 'react';

import FileChooser from 'ui-library/FileChooser';
import FileList from 'ui-library/FileList';
import FileRow from 'ui-library/FileRow';

import {SPREADSHEET_MIME_TYPE} from '../SpreadsheetBulkImportConstants';

interface UploadSpreadsheetFormProps {
  exampleImageURL: string;
  file?: File | null;
  fileWord: string;
  helpText?: string;
  onRemoveFile: () => void;
  onSelectFile: (file: File) => void;
  // The maximum number of rows can be imported to a table without exceeding the table row limit. When this value gets passed in, we validate the row count on spreadsheet upload.
  maxAllowedRowsToImport?: number;
}

export default function UploadSpreadsheetForm({
  exampleImageURL,
  file,
  fileWord,
  helpText,
  onRemoveFile,
  onSelectFile,
  maxAllowedRowsToImport,
}: UploadSpreadsheetFormProps): JSX.Element {
  return (
    <div {...getTestProps({component: 'UploadSpreadsheetForm', element: 'root'})}>
      {(() => {
        if (helpText) {
          return <p>{helpText}</p>;
        }
        return (
          <p>
            Upload a file to import into Benchling{exampleImageURL && ' (example below)'}. The first row
            should specify column headers, which must be unique. Each row after that should specify a{' '}
            {fileWord}.
          </p>
        );
      })()}
      <img className="bulkImportModal-spreadsheetPreviewImage" src={exampleImageURL} />
      {maxAllowedRowsToImport != null && (
        <p>The maximum number of rows that you can import is {maxAllowedRowsToImport}.</p>
      )}
      {(() => {
        if (file) {
          return (
            <FileList>
              <FileRow file={file} onRequestRemove={onRemoveFile} />
            </FileList>
          );
        } else {
          return (
            <FileChooser
              accept={SPREADSHEET_MIME_TYPE}
              multiple={false}
              onSelectFiles={onSelectFile}
              className="bulkImportModal-spreadsheetChooser"
            />
          );
        }
      })()}
    </div>
  );
}
